/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppSalesRouteImport } from './routes/_app.sales'
import { Route as AppPurchasesRouteImport } from './routes/_app.purchases'
import { Route as AppMastersRouteImport } from './routes/_app.masters'
import { Route as AppInventoryRouteImport } from './routes/_app.inventory'
import { Route as AppHrRouteImport } from './routes/_app.hr'
import { Route as AppSalesSalesmenRouteImport } from './routes/_app.sales.salesmen'
import { Route as AppSalesReturnsRouteImport } from './routes/_app.sales.returns'
import { Route as AppSalesEstimatesRouteImport } from './routes/_app.sales.estimates'
import { Route as AppSalesDashboardRouteImport } from './routes/_app.sales.dashboard'
import { Route as AppSalesBillsRouteImport } from './routes/_app.sales.bills'
import { Route as AppPurchasesReturnsRouteImport } from './routes/_app.purchases.returns'
import { Route as AppInventoryTransfersRouteImport } from './routes/_app.inventory.transfers'
import { Route as AppInventoryMovementRouteImport } from './routes/_app.inventory.movement'
import { Route as AppAdminUsersRouteImport } from './routes/_app.admin.users'
import { Route as AppHrEmployeesIdRouteImport } from './routes/_app.hr.employees.$id'
import { Route as AppSalesBillStoreCodeBillDateBillNoRouteImport } from './routes/_app.sales.bill.$storeCode.$billDate.$billNo'
import { Route as AppPurchasesBillStoreCodeBillDateBillNoRouteImport } from './routes/_app.purchases.bill.$storeCode.$billDate.$billNo'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesRoute = AppSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasesRoute = AppPurchasesRouteImport.update({
  id: '/purchases',
  path: '/purchases',
  getParentRoute: () => AppRoute,
} as any)
const AppMastersRoute = AppMastersRouteImport.update({
  id: '/masters',
  path: '/masters',
  getParentRoute: () => AppRoute,
} as any)
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRoute,
} as any)
const AppHrRoute = AppHrRouteImport.update({
  id: '/hr',
  path: '/hr',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesSalesmenRoute = AppSalesSalesmenRouteImport.update({
  id: '/salesmen',
  path: '/salesmen',
  getParentRoute: () => AppSalesRoute,
} as any)
const AppSalesReturnsRoute = AppSalesReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => AppSalesRoute,
} as any)
const AppSalesEstimatesRoute = AppSalesEstimatesRouteImport.update({
  id: '/estimates',
  path: '/estimates',
  getParentRoute: () => AppSalesRoute,
} as any)
const AppSalesDashboardRoute = AppSalesDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppSalesRoute,
} as any)
const AppSalesBillsRoute = AppSalesBillsRouteImport.update({
  id: '/bills',
  path: '/bills',
  getParentRoute: () => AppSalesRoute,
} as any)
const AppPurchasesReturnsRoute = AppPurchasesReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => AppPurchasesRoute,
} as any)
const AppInventoryTransfersRoute = AppInventoryTransfersRouteImport.update({
  id: '/transfers',
  path: '/transfers',
  getParentRoute: () => AppInventoryRoute,
} as any)
const AppInventoryMovementRoute = AppInventoryMovementRouteImport.update({
  id: '/movement',
  path: '/movement',
  getParentRoute: () => AppInventoryRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRoute,
} as any)
const AppHrEmployeesIdRoute = AppHrEmployeesIdRouteImport.update({
  id: '/employees/$id',
  path: '/employees/$id',
  getParentRoute: () => AppHrRoute,
} as any)
const AppSalesBillStoreCodeBillDateBillNoRoute =
  AppSalesBillStoreCodeBillDateBillNoRouteImport.update({
    id: '/bill/$storeCode/$billDate/$billNo',
    path: '/bill/$storeCode/$billDate/$billNo',
    getParentRoute: () => AppSalesRoute,
  } as any)
const AppPurchasesBillStoreCodeBillDateBillNoRoute =
  AppPurchasesBillStoreCodeBillDateBillNoRouteImport.update({
    id: '/bill/$storeCode/$billDate/$billNo',
    path: '/bill/$storeCode/$billDate/$billNo',
    getParentRoute: () => AppPurchasesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/hr': typeof AppHrRouteWithChildren
  '/inventory': typeof AppInventoryRouteWithChildren
  '/masters': typeof AppMastersRoute
  '/purchases': typeof AppPurchasesRouteWithChildren
  '/sales': typeof AppSalesRouteWithChildren
  '/admin/users': typeof AppAdminUsersRoute
  '/inventory/movement': typeof AppInventoryMovementRoute
  '/inventory/transfers': typeof AppInventoryTransfersRoute
  '/purchases/returns': typeof AppPurchasesReturnsRoute
  '/sales/bills': typeof AppSalesBillsRoute
  '/sales/dashboard': typeof AppSalesDashboardRoute
  '/sales/estimates': typeof AppSalesEstimatesRoute
  '/sales/returns': typeof AppSalesReturnsRoute
  '/sales/salesmen': typeof AppSalesSalesmenRoute
  '/hr/employees/$id': typeof AppHrEmployeesIdRoute
  '/purchases/bill/$storeCode/$billDate/$billNo': typeof AppPurchasesBillStoreCodeBillDateBillNoRoute
  '/sales/bill/$storeCode/$billDate/$billNo': typeof AppSalesBillStoreCodeBillDateBillNoRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/hr': typeof AppHrRouteWithChildren
  '/inventory': typeof AppInventoryRouteWithChildren
  '/masters': typeof AppMastersRoute
  '/purchases': typeof AppPurchasesRouteWithChildren
  '/sales': typeof AppSalesRouteWithChildren
  '/': typeof AppIndexRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/inventory/movement': typeof AppInventoryMovementRoute
  '/inventory/transfers': typeof AppInventoryTransfersRoute
  '/purchases/returns': typeof AppPurchasesReturnsRoute
  '/sales/bills': typeof AppSalesBillsRoute
  '/sales/dashboard': typeof AppSalesDashboardRoute
  '/sales/estimates': typeof AppSalesEstimatesRoute
  '/sales/returns': typeof AppSalesReturnsRoute
  '/sales/salesmen': typeof AppSalesSalesmenRoute
  '/hr/employees/$id': typeof AppHrEmployeesIdRoute
  '/purchases/bill/$storeCode/$billDate/$billNo': typeof AppPurchasesBillStoreCodeBillDateBillNoRoute
  '/sales/bill/$storeCode/$billDate/$billNo': typeof AppSalesBillStoreCodeBillDateBillNoRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/hr': typeof AppHrRouteWithChildren
  '/_app/inventory': typeof AppInventoryRouteWithChildren
  '/_app/masters': typeof AppMastersRoute
  '/_app/purchases': typeof AppPurchasesRouteWithChildren
  '/_app/sales': typeof AppSalesRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/inventory/movement': typeof AppInventoryMovementRoute
  '/_app/inventory/transfers': typeof AppInventoryTransfersRoute
  '/_app/purchases/returns': typeof AppPurchasesReturnsRoute
  '/_app/sales/bills': typeof AppSalesBillsRoute
  '/_app/sales/dashboard': typeof AppSalesDashboardRoute
  '/_app/sales/estimates': typeof AppSalesEstimatesRoute
  '/_app/sales/returns': typeof AppSalesReturnsRoute
  '/_app/sales/salesmen': typeof AppSalesSalesmenRoute
  '/_app/hr/employees/$id': typeof AppHrEmployeesIdRoute
  '/_app/purchases/bill/$storeCode/$billDate/$billNo': typeof AppPurchasesBillStoreCodeBillDateBillNoRoute
  '/_app/sales/bill/$storeCode/$billDate/$billNo': typeof AppSalesBillStoreCodeBillDateBillNoRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/hr'
    | '/inventory'
    | '/masters'
    | '/purchases'
    | '/sales'
    | '/admin/users'
    | '/inventory/movement'
    | '/inventory/transfers'
    | '/purchases/returns'
    | '/sales/bills'
    | '/sales/dashboard'
    | '/sales/estimates'
    | '/sales/returns'
    | '/sales/salesmen'
    | '/hr/employees/$id'
    | '/purchases/bill/$storeCode/$billDate/$billNo'
    | '/sales/bill/$storeCode/$billDate/$billNo'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/hr'
    | '/inventory'
    | '/masters'
    | '/purchases'
    | '/sales'
    | '/'
    | '/admin/users'
    | '/inventory/movement'
    | '/inventory/transfers'
    | '/purchases/returns'
    | '/sales/bills'
    | '/sales/dashboard'
    | '/sales/estimates'
    | '/sales/returns'
    | '/sales/salesmen'
    | '/hr/employees/$id'
    | '/purchases/bill/$storeCode/$billDate/$billNo'
    | '/sales/bill/$storeCode/$billDate/$billNo'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/hr'
    | '/_app/inventory'
    | '/_app/masters'
    | '/_app/purchases'
    | '/_app/sales'
    | '/_app/'
    | '/_app/admin/users'
    | '/_app/inventory/movement'
    | '/_app/inventory/transfers'
    | '/_app/purchases/returns'
    | '/_app/sales/bills'
    | '/_app/sales/dashboard'
    | '/_app/sales/estimates'
    | '/_app/sales/returns'
    | '/_app/sales/salesmen'
    | '/_app/hr/employees/$id'
    | '/_app/purchases/bill/$storeCode/$billDate/$billNo'
    | '/_app/sales/bill/$storeCode/$billDate/$billNo'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales': {
      id: '/_app/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof AppSalesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchases': {
      id: '/_app/purchases'
      path: '/purchases'
      fullPath: '/purchases'
      preLoaderRoute: typeof AppPurchasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/masters': {
      id: '/_app/masters'
      path: '/masters'
      fullPath: '/masters'
      preLoaderRoute: typeof AppMastersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr': {
      id: '/_app/hr'
      path: '/hr'
      fullPath: '/hr'
      preLoaderRoute: typeof AppHrRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/salesmen': {
      id: '/_app/sales/salesmen'
      path: '/salesmen'
      fullPath: '/sales/salesmen'
      preLoaderRoute: typeof AppSalesSalesmenRouteImport
      parentRoute: typeof AppSalesRoute
    }
    '/_app/sales/returns': {
      id: '/_app/sales/returns'
      path: '/returns'
      fullPath: '/sales/returns'
      preLoaderRoute: typeof AppSalesReturnsRouteImport
      parentRoute: typeof AppSalesRoute
    }
    '/_app/sales/estimates': {
      id: '/_app/sales/estimates'
      path: '/estimates'
      fullPath: '/sales/estimates'
      preLoaderRoute: typeof AppSalesEstimatesRouteImport
      parentRoute: typeof AppSalesRoute
    }
    '/_app/sales/dashboard': {
      id: '/_app/sales/dashboard'
      path: '/dashboard'
      fullPath: '/sales/dashboard'
      preLoaderRoute: typeof AppSalesDashboardRouteImport
      parentRoute: typeof AppSalesRoute
    }
    '/_app/sales/bills': {
      id: '/_app/sales/bills'
      path: '/bills'
      fullPath: '/sales/bills'
      preLoaderRoute: typeof AppSalesBillsRouteImport
      parentRoute: typeof AppSalesRoute
    }
    '/_app/purchases/returns': {
      id: '/_app/purchases/returns'
      path: '/returns'
      fullPath: '/purchases/returns'
      preLoaderRoute: typeof AppPurchasesReturnsRouteImport
      parentRoute: typeof AppPurchasesRoute
    }
    '/_app/inventory/transfers': {
      id: '/_app/inventory/transfers'
      path: '/transfers'
      fullPath: '/inventory/transfers'
      preLoaderRoute: typeof AppInventoryTransfersRouteImport
      parentRoute: typeof AppInventoryRoute
    }
    '/_app/inventory/movement': {
      id: '/_app/inventory/movement'
      path: '/movement'
      fullPath: '/inventory/movement'
      preLoaderRoute: typeof AppInventoryMovementRouteImport
      parentRoute: typeof AppInventoryRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hr/employees/$id': {
      id: '/_app/hr/employees/$id'
      path: '/employees/$id'
      fullPath: '/hr/employees/$id'
      preLoaderRoute: typeof AppHrEmployeesIdRouteImport
      parentRoute: typeof AppHrRoute
    }
    '/_app/sales/bill/$storeCode/$billDate/$billNo': {
      id: '/_app/sales/bill/$storeCode/$billDate/$billNo'
      path: '/bill/$storeCode/$billDate/$billNo'
      fullPath: '/sales/bill/$storeCode/$billDate/$billNo'
      preLoaderRoute: typeof AppSalesBillStoreCodeBillDateBillNoRouteImport
      parentRoute: typeof AppSalesRoute
    }
    '/_app/purchases/bill/$storeCode/$billDate/$billNo': {
      id: '/_app/purchases/bill/$storeCode/$billDate/$billNo'
      path: '/bill/$storeCode/$billDate/$billNo'
      fullPath: '/purchases/bill/$storeCode/$billDate/$billNo'
      preLoaderRoute: typeof AppPurchasesBillStoreCodeBillDateBillNoRouteImport
      parentRoute: typeof AppPurchasesRoute
    }
  }
}

interface AppHrRouteChildren {
  AppHrEmployeesIdRoute: typeof AppHrEmployeesIdRoute
}

const AppHrRouteChildren: AppHrRouteChildren = {
  AppHrEmployeesIdRoute: AppHrEmployeesIdRoute,
}

const AppHrRouteWithChildren = AppHrRoute._addFileChildren(AppHrRouteChildren)

interface AppInventoryRouteChildren {
  AppInventoryMovementRoute: typeof AppInventoryMovementRoute
  AppInventoryTransfersRoute: typeof AppInventoryTransfersRoute
}

const AppInventoryRouteChildren: AppInventoryRouteChildren = {
  AppInventoryMovementRoute: AppInventoryMovementRoute,
  AppInventoryTransfersRoute: AppInventoryTransfersRoute,
}

const AppInventoryRouteWithChildren = AppInventoryRoute._addFileChildren(
  AppInventoryRouteChildren,
)

interface AppPurchasesRouteChildren {
  AppPurchasesReturnsRoute: typeof AppPurchasesReturnsRoute
  AppPurchasesBillStoreCodeBillDateBillNoRoute: typeof AppPurchasesBillStoreCodeBillDateBillNoRoute
}

const AppPurchasesRouteChildren: AppPurchasesRouteChildren = {
  AppPurchasesReturnsRoute: AppPurchasesReturnsRoute,
  AppPurchasesBillStoreCodeBillDateBillNoRoute:
    AppPurchasesBillStoreCodeBillDateBillNoRoute,
}

const AppPurchasesRouteWithChildren = AppPurchasesRoute._addFileChildren(
  AppPurchasesRouteChildren,
)

interface AppSalesRouteChildren {
  AppSalesBillsRoute: typeof AppSalesBillsRoute
  AppSalesDashboardRoute: typeof AppSalesDashboardRoute
  AppSalesEstimatesRoute: typeof AppSalesEstimatesRoute
  AppSalesReturnsRoute: typeof AppSalesReturnsRoute
  AppSalesSalesmenRoute: typeof AppSalesSalesmenRoute
  AppSalesBillStoreCodeBillDateBillNoRoute: typeof AppSalesBillStoreCodeBillDateBillNoRoute
}

const AppSalesRouteChildren: AppSalesRouteChildren = {
  AppSalesBillsRoute: AppSalesBillsRoute,
  AppSalesDashboardRoute: AppSalesDashboardRoute,
  AppSalesEstimatesRoute: AppSalesEstimatesRoute,
  AppSalesReturnsRoute: AppSalesReturnsRoute,
  AppSalesSalesmenRoute: AppSalesSalesmenRoute,
  AppSalesBillStoreCodeBillDateBillNoRoute:
    AppSalesBillStoreCodeBillDateBillNoRoute,
}

const AppSalesRouteWithChildren = AppSalesRoute._addFileChildren(
  AppSalesRouteChildren,
)

interface AppRouteChildren {
  AppHrRoute: typeof AppHrRouteWithChildren
  AppInventoryRoute: typeof AppInventoryRouteWithChildren
  AppMastersRoute: typeof AppMastersRoute
  AppPurchasesRoute: typeof AppPurchasesRouteWithChildren
  AppSalesRoute: typeof AppSalesRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppHrRoute: AppHrRouteWithChildren,
  AppInventoryRoute: AppInventoryRouteWithChildren,
  AppMastersRoute: AppMastersRoute,
  AppPurchasesRoute: AppPurchasesRouteWithChildren,
  AppSalesRoute: AppSalesRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
